export default "__VITE_ASSET__3f4f931b__"